// import {genActiveRule, render} from './index';
// 使用qiankun2.0container装载子应用方法 无需引用render函数
import {genActiveRule, render} from './index';
import LibraryJs from '../common/js';
import store from '@/store';
import * as LibraryAPI from '../service';
import * as childEmit from './childEmit';
import {getToken} from '@/library/js/auth.js';
import {
    valInDeep,
    flattenDeep
} from '@/library/js/array.js';

// import actions from '@/util/actions'

/**
 * @name qiankun2.0 container装载子应用方法 声明子应用挂载dom；
 */
// const app
// 定义传入子应用的数据Container = "#subapp-viewport";

let propObj = {
    data: store.getters, // 从主应用仓库读出的数据
    utils: LibraryJs, // 从主应用读出的工具类库
    service: LibraryAPI, // 从主应用读出封装的API层
    emitFnc: childEmit, // 从主应用下发emit函数来收集子应用反馈
    baseUrl: process.env.VUE_APP_APIURL, //请求service的BASE_URL
    // actions:actions
};

/**
 * 根据用户id 获取用户权限（应用和应用的菜单）
 */
function findUserAppAndMenu (userParam, cb) {
    store.dispatch('menu/setAppsMenuData', userParam).then(res => {
        cb();
    }).catch(res => {
        console.log(res);
    });
}

/**
 * 根据项目、应用菜单组成项目注册信息
 * projects：项目id
 * appRoutesList  应用菜单信息
 */
function renderAppsData (projects, appList, allAppMenuList) {
    let registAppData = [];
    projects.forEach((item) => {
        if (item.name != undefined) {
            //遍历所有菜单 根据当前项目的路由前缀查找出当前项目的菜单 并传递给子应用
            let curAppMenuArr = valInDeep(allAppMenuList, item.route_prefix, 'module', 'children');
            item.menu = curAppMenuArr;
            // 根据当前项目的菜单数据 遍历出需要的路由数据
            let urlObj = JSON.parse(item.json);
            registAppData.push({
                name: item.name,
                entry: urlObj[process.env.VUE_APP_SUBURL],
                render,
                // container: appContainer,
                activeRule: genActiveRule('/' + item.route_prefix),
                props: {...propObj, ROUTES: curAppMenuArr, routerBase: item.route_prefix}
                // props: {...propObj, ROUTES: item.menuRoutes, routerBase: item.route_prefix}
            });
        }
    });
    return registAppData;
}

/**
 * 拼接完整path路径 子应用唯一标识+路径 用于左侧菜单展示
 */
function traverseRoutes (menus) {
    //深拷贝数组 修改数据内对象属性值 原数组不变
    let mainMenus = JSON.parse(JSON.stringify(menus));
    let routes = mainMenus.map(menu => {
        if (menu.path) {
            menu.path = '/' + menu.module + menu.path;
            //处理资源应用 我的资源nodePath默认为0的问题
            if (menu.module === 'resource' && menu.path.indexOf('nodePath') > 0) {
                menu.path = menu.path.replace(":nodePath", "0");
            }
        }

        if (menu.children && menu.children.length) {
            menu.children = traverseRoutes(menu.children);
        }
        return menu;
    });
    return routes;
}

/**
 * 遍历菜单集合 将菜单数据转为路由数据
 */
function renderRouterByMenu (menus, isAppendModule) {
    //深拷贝数组 修改数据内对象属性值 原数组不变
    let mainMenus = JSON.parse(JSON.stringify(menus));
    let routes = mainMenus.map(menu => {
        menu = getRouterObj(menu);
        if (isAppendModule) {
            if (menu.path && menu.openMode == 0) {
                menu.path = '/' + menu.module + menu.path;
                //处理资源应用 我的资源nodePath默认为0的问题
                if (menu.module === 'resource' && menu.path.indexOf('nodePath') > 0) {
                    menu.path = menu.path.replace(":nodePath", "0");
                }
            }
        }
        if (menu.children && menu.children.length) {
            menu.children = renderRouterByMenu(menu.children, isAppendModule);
        }
        return menu;
    });
    return routes;
}

/**
 * 根据菜单数据转换路由信息
 */
function getRouterObj (data) {
    return {
        id: data.id,
        title: data.title,
        path: data.path,
        name: data.name,
        component: data.component,
        menuShow: data.isShow,
        leaf: data.isLeaf == '1',
        isCache: data.isCache == '1',
        icon: data.icon,
        children: data.children,
        appId: data.appId,
        appName: data.appName,
        parentId: data.parentId,
        module: data.projectRoutePrefix,
        openMode: data.openMode
    };
}

/**
 * 遍历应用菜单 返回新的菜单集合
 */
function composeAllAppMenuList (appList) {
    let allAppMenuList = [];

    appList.forEach((item) => {
        let curMenus = renderRouterByMenu(item.menuTreeList, false);
        allAppMenuList = allAppMenuList.concat(curMenus);
    });
    return allAppMenuList;
}

/**
 * 替换url链接里定义的用户id token等参数
 */
function replaceParams (url) {
    url = url.replace('${userId}', store.getters.userId);
    url = url.replace('${token}', ssoClient.getCookie() || getToken());
    // 用于金陵微课域名跳转到金陵微课的数据展板地址
    if (url.indexOf('school.iclass30.com') > -1 && window.location.host == 'jlwxconsole.iclass30.com') {
        url = url.replace('school.iclass30.com', 'jlwxdata.iclass30.com');
    }
    return url;
}

/**
 * 获取有权限的路由
 */
function composeAllRoutesList (projects, allAppMenuList) {
    allAppMenuList = flattenDeep(allAppMenuList, 'children');
    let allMenuRoutesList = [];
    let tempArr = [];
    // TODO 后期更改为从后台获取路由
    projects.forEach((item) => {
        try {
            const value = require('../router/subRoute/' + item.route_prefix + '.js');
            const curRoutes = value.default;
            let routesObj = {};
            routesObj.module = item.route_prefix;
            routesObj.routes = curRoutes;
            tempArr.push(routesObj);
        } catch (e) {
            console.log(e);
        }
    });
    allAppMenuList.forEach((item) => {
        let moduleRoutes = tempArr.filter(i => i.module == item.module)[0];
        if (moduleRoutes) {
            let menuRoutes = moduleRoutes.routes.filter(i => i.parent ? (i.name == item.name || i.parent.includes(item.name)) : i.name == item.name);
            if (menuRoutes.length > 0) {
                menuRoutes.forEach((i) => {
                    let meat = {};
                    meat.appId = item.appId;
                    meat.menuId = item.id;
                    meat.module = item.module;
                    i.meat = meat;
                    if (i.children) {
                        i.children.forEach((subI) => {
                            let subMeat = {};
                            subMeat.appId = item.appId;
                            subMeat.menuId = item.id;
                            subMeat.module = item.module;
                            subI.meat = subMeat;
                        });
                    }
                    allMenuRoutesList.push(i);
                });
            }
            projects.forEach((i) => {
                if (i.route_prefix == item.module)
                    i.menuRoutes = allMenuRoutesList;
            });
        }
    });
    return allMenuRoutesList;
}


export {
    findUserAppAndMenu, //获取用户的应用菜单权限
    renderAppsData, // 应用注册信息
    traverseRoutes, //拼接完整path路径
    composeAllAppMenuList, //获取所有应用下的菜单
    renderRouterByMenu, //菜单数据转化为路由数据
    replaceParams,
    composeAllRoutesList//替换url链接里定义的用户id token等参数
};

